import React from 'react';
import { parseISO } from 'date-fns';
import { DatePicker } from '@atlaskit/datetime-picker';
import { Field as AkField, ErrorMessage as AkErrorMessage } from '@atlaskit/form';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { formatWithLocale } from '@atlassian/jira-platform-utils-date-fns/src/main.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import { useLocale as useLocaleDI } from '@atlassian/jira-tenant-context-controller/src/components/locale/index.tsx';
import {
	HOLIDAY_DATE_PREFIX,
	EMPTY,
	INVALID_DATE,
} from '../../../../../../../common/ui/constants.tsx';
import messages from './messages';
import { validateDate } from './utils';

type Props = Intl & {
	fieldId: number;
	defaultDate: string;
	useLocale?: typeof useLocaleDI;
};

export const DateView = ({
	intl: { formatMessage },
	fieldId,
	defaultDate,
	useLocale = useLocaleDI,
}: Props) => {
	const locale = useLocale().replace('_', '-');
	return (
		<AkField
			name={`${HOLIDAY_DATE_PREFIX}${fieldId}`}
			label={formatMessage(messages.date)}
			defaultValue={defaultDate}
			// @ts-expect-error - TS2322 - Type '(date: string) => string | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
			validate={validateDate}
		>
			{({ fieldProps: { value, onChange }, error }) => (
				<>
					<DatePicker
						locale={locale}
						defaultValue={value ? formatWithLocale(parseISO(value), 'yyyy-MM-dd', locale) : value}
						onChange={(selectedValue) => {
							onChange(selectedValue);
						}}
						// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'boolean | undefined'.
						isInvalid={error}
						testId="servicedesk-sla-settings.ui.calendars.editable.fields.holidays.holiday.date"
					/>
					{error === EMPTY && <AkErrorMessage>{formatMessage(messages.emptyDate)}</AkErrorMessage>}
					{error === INVALID_DATE && (
						<AkErrorMessage>{formatMessage(messages.invalidDate)}</AkErrorMessage>
					)}
				</>
			)}
		</AkField>
	);
};

export const DateField = injectIntl(DateView);
